import React from 'react';
interface RadioQuestionProps {
  options: string[];
  selectedValue: string | null;
  onChange: (value: string) => void;
  name: string;
}
export function RadioQuestion({
  options,
  selectedValue,
  onChange,
  name
}: RadioQuestionProps) {
  return <div className="space-y-3" role="radiogroup" data-id="element-106">
      {options.map((option, index) => <label key={index} className={`flex items-center p-4 border-2 rounded-lg cursor-pointer transition-all min-h-[56px] ${selectedValue === option ? 'border-crown-red bg-crown-red bg-opacity-10' : 'border-crown-border bg-crown-surface hover:border-crown-muted'}`} data-id="element-107">
          <input type="radio" name={name} value={option} checked={selectedValue === option} onChange={e => onChange(e.target.value)} className="sr-only" data-id="element-108" />
          <div className={`w-5 h-5 rounded-full border-2 flex items-center justify-center flex-shrink-0 ${selectedValue === option ? 'border-crown-red' : 'border-crown-border'}`} data-id="element-109">
            {selectedValue === option && <div className="w-3 h-3 rounded-full bg-crown-red" data-id="element-110" />}
          </div>
          <span className={`ml-3 text-base ${selectedValue === option ? 'text-crown-text font-medium' : 'text-crown-body'}`} data-id="element-111">
            {option}
          </span>
        </label>)}
    </div>;
}